import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
`;

export const Title = styled.h1`
  ${({ theme }) => typographyToCss(theme.typography.h5)};
  flex: 1;
  display: block;

  margin: 0;
  padding: 0;

  color: ${({ theme }) => theme.palette.text.primary};

  &::first-letter {
    text-transform: uppercase;
  }
`;

export const CenterInteractions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const Interactions = styled.div<{ $selected: boolean }>`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1.5)};

  white-space: nowrap;
  color: ${({ theme, $selected }) =>
    $selected ? theme.palette.text.primary : theme.palette.grey[700]};
`;
